import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService, UserService} from "../services";
import { Subject } from 'rxjs';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import {first} from "rxjs/operators";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {Page} from "../models/page";
import {Items} from "../models/items";
import {FormGroup} from "@angular/forms";
import {DeleteUserDialogComponent} from "../user/dialog/deleteUserDialog.component";
import {User} from "../models";
import {MatDialog} from "@angular/material/dialog";
import {ResourceService} from "../services/resource.service";
import {Resource} from "../models/resource";

@Component({
    templateUrl: './resourceOnline.component.html',
    styleUrls: ['./resourceOnline.component.scss']
})
export class ResourceOnlineComponent implements OnDestroy, OnInit {
    rows: Resource[];
    loadingIndicator: boolean;
    reorderable: boolean;
    filterValue: string;
    page = new Page();
    @ViewChild(DatatableComponent) table: DatatableComponent;
    deleteDialogRef: any;
    view: string = 'preview';

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private _fuseSidebarService: FuseSidebarService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        public _matDialog: MatDialog,
        private resourceService: ResourceService,
    ) {
        // Set the defaults
        this.loadingIndicator = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Resources online');
    }

    ngOnInit() {

    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    /**
     * Toggle the sidebar
     *
     * @param name
     */
    toggleSidebar(name): void
    {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }


    filterByCategory(id: string|null) {
        console.log(id);
        if (id !== null) {
            this.resourceService.getAllByCategory(id).subscribe((res: Resource[]) => {
                this.rows = res;
                this.loadingIndicator = false;
            }, error => {
                this.alertService.error(error);
            });
        } else {
        //     this.findAll();
        }
    }
}
